import React from 'react';
import { Alert, Box, Button } from '@mui/material';

class FlowErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: '' };
  }

  static getDerivedStateFromError(error) {
    // ResizeObserver errors are now handled globally, so we don't need to check for them here
    return { hasError: true, errorMessage: error.message };
  }

  componentDidCatch(error, errorInfo) {
    // Log error details for debugging
    console.error('Flow Editor Error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 2 }}>
          <Alert 
            severity="error"
            action={
              <Button 
                onClick={() => {
                  this.setState({ hasError: false, errorMessage: '' });
                  // Force a re-render by reloading the page if retry doesn't work
                  window.location.reload();
                }}
                size="small"
                color="inherit"
              >
                Retry
              </Button>
            }
          >
            <strong>Flow Editor Error:</strong> {this.state.errorMessage}
            <br />
            <small>Click "Retry" to reload the editor and try again.</small>
          </Alert>
        </Box>
      );
    }

    return this.props.children;
  }
}

export default FlowErrorBoundary; 